<template>
  <div>
    <el-dialog
      :title="dataForm.id ? 'Edit Template' : 'Add Template'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="1000px"
      top="3vh"
    >
      <el-form :model="dataForm" :rules="dataRule" ref="formRef" label-position="top">
        <el-form-item label="Copy From" v-if="!dataForm.id">
          <el-select v-model="internalValue" clearable filterable placeholder="Select an existing data to copy" class="wdb100" @change="copyFromChange">
            <el-option
              v-for="(item, index) in templateList"
              :key="`template-${index}-${item.id}`"
              :label="`${item.title}-${item.subject}`"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Title" prop="title">
          <el-input v-model="dataForm.title" placeholder="Title" clearable></el-input>
        </el-form-item>
        <el-form-item label="Subject" prop="subject">
          <el-input v-model="dataForm.subject" placeholder="Subject" clearable></el-input>
        </el-form-item>
        <el-form-item label="Body" prop="body">
          <el-editor :height="450" v-model="dataForm.body" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">OK</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    templateList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      dataForm: {
        id: "",
        title: "",
        subject: "",
        body: "",
      },
      dataRule: {
        title: [{ required: true, message: "Please enter", trigger: "submit" }],
        subject: [{ required: true, message: "Please enter", trigger: "submit" }],
        body: [{ required: true, message: "Please enter", trigger: "submit" }],
      },
      submitLoading: false,
      internalValue: null,
    };
  },
  methods: {
    // 初始化
    async init(data) {
      this.submitLoading = false;
      this.dialogVisible = true;
      this.internalValue = null;
      await this.$nextTick();
      this.$refs.formRef.resetFields();
      if (data) {
        this.dataForm = {
          id: data.id,
          title: data.title,
          subject: data.subject,
          body: data.body,
        };
      } else {
        this.$set(this.dataForm, "id", null);
      }
    },
    // 表单提交
    async formSubmitRequest() {
      const params = {
        ...this.dataForm,
      };
      if (params.id) {
        return this.$http.post(`/admin/promoEmailTemplate/${params.id}/update`, params);
      } else {
        return this.$http.post("/admin/promoEmailTemplate/create", params);
      }
    },
    dataFormSubmit() {
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          this.formSubmitRequest()
            .then(res => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.dialogVisible = false;
                  this.$emit("update");
                },
              });
            })
            .catch(err => {
              this.submitLoading = false;
            });
        }
      });
    },
    // Copy From 选中值发生改变时
    copyFromChange(id) {
      const data = this.templateList.find(item => item.id === id);
      if (!data) return;
      this.$set(this.dataForm, "title", data.title || "");
      this.$set(this.dataForm, "subject", data.subject || "");
      this.$set(this.dataForm, "body", data.body || "");
    },
  },
};
</script>

<style lang="scss" scoped></style>
